import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from '@codex/icons';
import { useToggle } from '@codex/hooks';
import { connect } from 'react-redux';
import scrollToElement from 'scroll-to-element';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import { creditMassageClose, creditMassageOpen, creditMassageMoreInfo } from '../../../analytics';

const CreditLabelContainer = styled.div`
padding: 10px 0;
cursor: pointer;

color: ${(props) => props.theme.colors.primary.purple};
span {
  width: 10px;
  height: 21px;
  cursor: pointer;
}
p {
  font-weight: bold;
  font-size: 13px;
  margin: 0;
  text-align: center;
}
`;

const HeaderContainer = styled.div`
  p {
    margin: 0;
    font-size: 14px;
  }
  strong {
    font-size: 16px;
  }
  display: flex;
  span {
    width: 35px;
  }
`;

const CreditContentContainer = styled.div`
  margin-top: ${({ isMobile }) => (isMobile ? '10px' : 0)};
  text-align: left;
  position: relative;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  font-size: 13px;
  box-shadow: 0px 5px 5px #CCC;

  &:before {
    content: '';
    position: absolute;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #F5F5F5;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
    clear: both;
  }
`;

const StyledHr = styled.hr`
  border-top: 1px solid grey;
  margin: 7px 0;
`;

const ContentTextContainer = styled.div`
  p {
    margin-bottom: 5px;
  }
`;

const MoreInfo = styled.a`
  cursor: pointer;
`;

const Credit = ({
  isMobile, productId, translations, translationsParams
}) => {

  useEffect(() => {
    const linksContainer = document.querySelectorAll('.prd-links-container')[1];
    const links = document.querySelectorAll('.prd-links')[1];

    linksContainer.style.width = '100%';
    links.style.width = '100%';
  }, []);

  const [active, toggle] = useToggle();
  const rotate = active ? 180 : 0;
  const toggleText = active ? 'See less' : 'See more';

  const {
    interest, monthlyPayment, price, totalAmountPayable, numberOfMonthlyPayments
  } = translationsParams;

  const formatedInterest = Math.round(interest * 10) / 10;

  const translationsWithParams = {
    detail: translations.detail.replace('[INTEREST]', formatedInterest),
    caption: translations.caption.replace('[MONTHLY_PAYMENT]', monthlyPayment),
    example: translations.example
      .replace('[MONTHLY_PAYMENT]', monthlyPayment)
      .replace('[NUMBER_OF_MONTHLY_PAYMENTS]', numberOfMonthlyPayments)
      .replace('[PRICE]', price)
      .replace('[TOTAL_AMOUNT_PAYABLE]', totalAmountPayable)
      .replace('[INTEREST]', formatedInterest)
      .replace('[INTEREST]', formatedInterest)
  };

  const handleCredit = () => {
    if (active) {
      creditMassageClose(productId);
    } else {
      creditMassageOpen(productId);
    }

    toggle(!active);
  };

  const creditMoreInfoAnalytics = () => {
    creditMassageMoreInfo(productId);
    const element = document.querySelector('[href="#tab5"]');
    element.click();
    setTimeout(() => {
      scrollToElement('#your-plan-information', {
        offset: -80,
        ease: 'linear',
        duration: 300
      });
    }, 500);
  };

  return (
    <EnvironmentThemeProvider>
      {
        !isMobile && (
          <CreditLabelContainer onClick={handleCredit}>
            <p>
              {' '}
              {translationsWithParams.detail}
              {' '}
            </p>
            <p>
              {' '}
              {toggleText}
              {' '}
              <Icon icon={'ArrowDown'} rotate={rotate} />
              {' '}
            </p>
          </CreditLabelContainer>
        )
}
      {
        (active || isMobile) && (
          <CreditContentContainer isMobile={isMobile}>
            <HeaderContainer>
              <p dangerouslySetInnerHTML={{ __html: translationsWithParams.caption }} />
            </HeaderContainer>
            <StyledHr />
            <ContentTextContainer>
              <p dangerouslySetInnerHTML={{ __html: translationsWithParams.example }} />
              <MoreInfo onClick={creditMoreInfoAnalytics}> More info</MoreInfo>
            </ContentTextContainer>
          </CreditContentContainer>
        )
}
    </EnvironmentThemeProvider>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.general.device.isMobile,
  productId: state.productInfo.productID,
  translationsParams: {
    interest: window.digitalData['component.productCreditInfo.interest'],
    monthlyPayment: window.digitalData['component.productCreditInfo.monthlyPayment'],
    price: window.digitalData['component.productCreditInfo.price'],
    numberOfMonthlyPayments:
      window.digitalData['component.productCreditInfo.numberOfMonthlyPayments'],
    totalAmountPayable: window.digitalData['component.productCreditInfo.totalAmountPayable']
  }
});

Credit.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  productId: PropTypes.string.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  translationsParams: PropTypes.objectOf(PropTypes.string).isRequired
};

export default connect(mapStateToProps, null)(Credit);
